import { render } from "./refundDetail.vue?vue&type=template&id=737158c4&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"

import "./refundDetail.vue?vue&type=style&index=0&id=737158c4&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737158c4"]])

export default __exports__